export default {
    cn: {
        commissionSeek: {
            account: '账号',
            seek: '搜索',
            dropdown: {
                loginId: '登录账号',
                userName: '账户名称',
                IBcode: 'IB代码',
                phone: '电话',
                email: '电子邮箱',
            },
        },
    },
    hk: {
        commissionSeek: {
            account: '賬號',
            seek: '搜索',
            dropdown: {
                loginId: '登錄帳號',
                userName: '帳戶名稱',
                IBcode: 'IB代碼',
                phone: '電話',
                email: '電子郵箱',
            },
        }
    },
    en: {
        commissionSeek: {
            account: 'Account',
            seek: 'Search',
            dropdown: {
                loginId: 'Login Account',
                userName: 'Account Name',
                IBcode: 'IB Code',
                phone: 'Phone',
                email: 'Email',
            },
        }
    }
}


// WEBPACK FOOTER //
// ./src/MultiLanguage/CommissionSetting/commissionSeek.js